"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestingExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
class TestingExtension extends WidgetExtensionPlugin_1.default {
    initialize(widget) {
        return new Promise(resolve => {
            this.registerStepSetter(widget);
            this.registerErrorTriggerer(widget);
            resolve();
        });
    }
    registerStepSetter(widget) {
        widget.getEventContainer().on("testing set step", (stepId) => {
            console.log(`Attempting to manually set step: ${stepId}. Note that steps can decide whether they apply
        or not so this might have no effect.`);
            widget.setStep(stepId).catch(console.error);
        });
    }
    registerErrorTriggerer(widget) {
        widget.getEventContainer().on("testing trigger error", () => {
            console.log(`Triggering manual error for step.`);
            widget.getEventContainer().emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, new Error("Testing error."));
        });
    }
}
exports.default = TestingExtension;
exports.TestingExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "testing",
    class: TestingExtension
});
